<div class="sgt-representante-produtividade-widget card card-widget card-widget-navs">
    <div class="card-header card-header-horizontal">
        <div class="card-header-titles">
            <h6 class="card-title">
                {{title}}
            </h6>
            <small class="card-subtitle" *ngIf="subtitle">
                {{subtitle}}
            </small>
        </div>
    </div> 
    
    <div class="card-body" *ngIf="isLoading$ | async">
        <i class='fas fa-spinner fa-pulse'></i> Carregando
    </div>
    
    <div class="container-navs" *ngIf="!(isLoading$ | async)">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" 
                    [class.active]="state?.activeTab === tabs.GERAL" 
                    attr.data-target="#tabGeralRepresentanteProtuvidadeWidget_{{id}}" 
                    data-toggle="tab"
                    (click)="setActiveTab(tabs.GERAL)">
                    Geral
                </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" 
                    [class.active]="state?.activeTab === tabs.AQUISICAO" 
                    attr.data-target="#tabAquisicaoRepresentanteProtuvidadeWidget_{{id}}" 
                    data-toggle="tab"
                    (click)="setActiveTab(tabs.AQUISICAO)">
                    Aquisição de Clientes
                </a>                
            </li>            -->
        </ul>
        <div class="tab-content">
            <!-- Geral -->
            <div class="tab-pane" [class.active]="state?.activeTab === tabs.GERAL" id="tabGeralRepresentanteProtuvidadeWidget_{{id}}">
                <sgt-representante-produtividade-geral-kpi-table
                    #geralTable
                    [data]="state?.data">
                </sgt-representante-produtividade-geral-kpi-table>
            </div>
        
            <!-- Aquisição -->
            <!-- <div class="tab-pane" [class.active]="state?.activeTab === tabs.AQUISICAO" id="tabAquisicaoRepresentanteProtuvidadeWidget_{{id}}">
                <h4>Aquisição</h4>
            </div>           -->
        </div>
    </div>
</div>